module.exports = __webpack_public_path__ + "img/TV.4b60e259.png";